export default {
  languages: {
    spanish: 'Spanish',
    english: 'English',
    french: 'French',
    german: 'German'
  },
  name: 'Name',
};


// WEBPACK FOOTER //
// ./src/languages/en.js